<template>
  <v-app :style="{ background: computedBackgroundColor }">
    <div v-if="isLogged && !loading">          
      <Navbar :MenuItems="MenuItems"/>
      <Notification />
    </div>
    <Appbar v-if="isLogged" />
    <v-main>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Navbar from "@/components/shared/Navbar";
import Appbar from "@/components/shared/Appbar";
import Footer from "@/components/shared/Footer";
import Notification from "@/components/shared/Notification";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: { Navbar, Appbar, Footer, Notification },
  data: () => ({
    
  }),

  computed: {
    ...mapGetters({
      isLogged: "token",
      drawer: "drawer",
      notificationDrawer: "notificationDrawer",
      loading: "loading",
      role: "getRole",
      MenuItems: "getMenu",
    }),
    computedBackgroundColor() {
      return this.isLogged ? '#FBFBFB' : '#FFFFFF';
    },
  },

  watch: {
    getRole() {
      this.isMember();
    },
    
    
  },

  mounted() {
    
  },

  methods: {
    isMember() {
      if (this.role == "CLUB_MEMBER") {
        return true;
      } else {
        return false;
      }
    },

    

    isCpe() {
      if (this.role == "CLUBS_PERFORMANCE_EVALUATION") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
